import PropTypes from 'prop-types';
import styled from 'styled-components';
import Theme from '../../theme';
import { remCalc } from '@lux/helpers';

const Label = styled.label`
  ${Theme.fonts.styles.InputFieldLabels};
  padding-top: 3px;
  margin-bottom: ${Theme.spacing.xsmall};
  display: block;
  letter-spacing: ${remCalc(0.8)};
  font-weight: normal;
  cursor: default;
`;

Label.propTypes = {
  /** Label content */
  children: PropTypes.node,
  /** Extra class to apply to element */
  className: PropTypes.string,
  /** Form element this label is bound to */
  htmlFor: PropTypes.string
};

/** @component */
export default Label;
